import { connect } from 'react-redux'
import SaunaImageComponent from '../components/SaunaImageComponent'


const mapStateToProps = (state, ownProps) => {
    return {
        loading: state.materialImage.isLoading || ownProps.usePlaceholder,
        currentImage: usePlaceHolderImage(ownProps.usePlaceholder, state.materialImage.isLoading, ownProps.placeHolder) ? ownProps.placeHolder : state.materialImage.image,
        previousImage: usePlaceHolderImage(ownProps.usePlaceholder, state.materialImage.isLoading, ownProps.placeHolder) ? ownProps.placeHolder : state.materialImage.previousImage,
        mirror: state.benchModel.shape.mirrored || state.benchModel.mirrored 
    }
}
const SaunaMeasurementsContainer = connect(
    mapStateToProps
)(SaunaImageComponent)

export default SaunaMeasurementsContainer

let usePlaceHolderImage = (usePlaceholder, isLoading, placeholder) => {
    return usePlaceholder || (isLoading && placeholder)

}